import * as React from "react";
const SvgFiRrLion = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lion_svg__a)">
      <path
        fill="#062147"
        d="m23.268 5.854-.607-.604-.741-.651c-.003-.016-.01-.037-.005-.004C21.05 1.951 18.562.001 15.767.001c-2.746 0-6.291 1.241-8.023 4.013a1.6 1.6 0 0 0-.04 1.624c.227.41.616.698 1.06.803-.513.797-.81 1.715-.81 2.63 0 .554.11 2.483 1.518 4.062a1.57 1.57 0 0 0 1.739.419c.22-.085.414-.213.57-.372 1.006 1.537 2.457 3.29 4.219 4.56v3.762a.5.5 0 0 1-1 0v-2.5a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v2.5a.5.5 0 0 1-1 0v-3a1 1 0 0 0-.041-.281 26 26 0 0 0-.367-1.136c-.335-.986-.6-1.765-.593-3.078.005-.916.574-1.801 1.325-2.06a1 1 0 0 0-.65-1.891 3.7 3.7 0 0 0-1.433.922C3.899 11.091.36 12.417 0 18.947a.99.99 0 0 0 1 1.055 1 1 0 0 0 .998-.945c.109-1.986.537-3.347 1.029-4.277.084 1.206.37 2.06.672 2.949.099.289.2.59.3.919v2.854c0 1.379 1.123 2.5 2.5 2.5 1.379 0 2.5-1.121 2.5-2.5v-1.5h4v1.5c0 1.379 1.123 2.5 2.5 2.5 1.379 0 2.5-1.121 2.5-2.5v-4.59c.766-1.035 2.152-3.036 2.973-4.957C22.678 11.722 24 10.271 24 8.503v-.879a2.52 2.52 0 0 0-.732-1.768zm-6.782 9.737c-2.516-2.123-4.103-5.222-4.3-5.903a1 1 0 0 0-.96-.722c-.492.07-1 .502-1 1v.575a4.4 4.4 0 0 1-.271-1.472c0-.887.538-2.066 1.739-2.703a1 1 0 0 0-.47-1.884H9.872C11.318 2.781 13.85 2 15.766 2c1.37 0 2.623.617 3.446 1.628A4.26 4.26 0 0 0 16 7.75a4.26 4.26 0 0 0 2.86 4.017c-.712 1.461-1.734 2.948-2.374 3.824M22 8.5c0 .827-.673 1.5-1.5 1.5h-.25A2.253 2.253 0 0 1 18 7.75c0-1.124.83-2.047 1.96-2.212l1.333 1.169.56.561a.5.5 0 0 1 .147.354z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lion_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLion;
